import { TOOLBARS, getModalStyles } from 'wix-rich-content-editor-common';
import { Modals } from '../modals';
import AddVideo from '@wix/da-ds/pkg/Icons/24x24/AddVideo';
import linkModalConfig from './link-modal.config';
export default (({ helpers , t  })=>{
    return [
        {
            type: 'modal',
            name: 'Video',
            tooltip: t('editorToolbar.tooltips.addVideo'),
            getIcon: ()=>AddVideo,
            componentData: linkModalConfig,
            modalName: Modals.VIDEO_LINK,
            modalStyles: getModalStyles({
                fullScreen: false
            }),
            helpers,
            toolbars: [
                TOOLBARS.FOOTER,
                TOOLBARS.SIDE,
                TOOLBARS.INSERT_PLUGIN
            ]
        }
    ];
});
